import allProducts from './allProducts';
import { listExcludes, listIncludes, listRequires } from './util';

export default function tagProducts(
  includes: string[],
  excludes?: string[],
  requires?: string[],
  remove?: string,
  count?: number,
  start?: number,
  random?: boolean
) {
  var result = allProducts();

  if (includes) {
    result = result.filter((obj: any) => {
      return listIncludes(includes, obj.tags);
    });
  }

  if (requires) {
    result = result.filter((obj: any) => {
      return listRequires(requires, obj.tags);
    });
  }

  if (excludes) {
    result = result.filter((obj: any) => {
      return listExcludes(includes, excludes, obj.tags);
    });
  }

  if (random) {
    for (let i = 0; i < result.length; i++) {
      const a =
        Math.floor(Math.random() * result.length * 23 + 67) % result.length;
      const b =
        Math.floor(Math.random() * result.length * 23 + 67) % result.length;
      [result[b], result[a]] = [result[a], result[b]];
    }
  }

  if (count) {
    if (count > result.length) {
      count = result.length;
    }
  } else {
    count = result.length;
  }

  if (start) {
    if (start + count > result.length) {
      start = result.length - count;
    }
  } else {
    start = 0;
  }

  if (remove) {
    result = result.filter((x: any) => x.handle !== remove);
  }

  return result.slice(start, start + count);
}
